import { aggregateAccountData } from '../utils/account-aggregation';

export const createAnalyticsActions = (_set: any, get: any) => ({
  getAggregatedAccountData: () => aggregateAccountData(get()),
});
